import { render, staticRenderFns } from "./FilledCube.svg.vue?vue&type=template&id=4d813360"
import script from "./FilledCube.svg.vue?vue&type=script&lang=ts"
export * from "./FilledCube.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d813360')) {
      api.createRecord('4d813360', component.options)
    } else {
      api.reload('4d813360', component.options)
    }
    module.hot.accept("./FilledCube.svg.vue?vue&type=template&id=4d813360", function () {
      api.rerender('4d813360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/FilledCube.svg.vue"
export default component.exports